import {
  ADD_EMPLOYEE_FAIL,
  ADD_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_SUCCESS,
  GET_ALLEMPLOYEES_FAIL,
  GET_ALLEMPLOYEES_SUCCESS,
  UPDATE_EMPLOYEE_FAIL,
  UPDATE_EMPLOYEE_SUCCESS,
} from '../actions/actionTypes';
import { logout } from '../actions';
const employees = (state = [], action) => {
  switch (action.type) {
    case GET_ALLEMPLOYEES_SUCCESS:
      return [
        { ID: 1, Name: 'TOGO, TOGO' },
        ...getSortedEmployees(action.payload),
      ];
    case GET_ALLEMPLOYEES_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    case ADD_EMPLOYEE_SUCCESS:
      const afterAdd = [...state, action.payload];
      return [{ ID: 1, Name: 'TOGO, TOGO' }, ...getSortedEmployees(afterAdd)];
    case ADD_EMPLOYEE_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    case UPDATE_EMPLOYEE_SUCCESS:
      const updated = state.map((i) => {
        if (i.ID !== action.payload.ID) return i;
        else return action.payload;
      });
      return updated;
    case UPDATE_EMPLOYEE_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    case DELETE_EMPLOYEE_SUCCESS:
      const afterDeleted = state.filter(
        (i) => i.ID !== Number(action.payload.employeeId),
      );
      return afterDeleted;
    default:
      return state;
  }
};

const getSortedEmployees = (employees) => {
  const togo = employees.filter((i) => i.ID === 1);
  let sorted = [];
  if (togo.length === 0) {
    sorted = employees.sort((a, b) => a.Name.localeCompare(b.Name));
  } else {
    const filtered = employees.filter((i) => i.ID !== 1);
    sorted = filtered.sort((a, b) => a.Name.localeCompare(b.Name));
  }
  return sorted;
};

export default employees;
